export default __webpack_public_path__ + "static/media/page-title-bg-05.2eccac92.jpg";